//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'packageDescribe'
}



// WEBPACK FOOTER //
// ./src/components/more/packageDescribe.vue